(function(){

    function switchStates(e) {
        let target = e.target;
        let id = target.id;
        let countryId = target.options[target.selectedIndex].value;
        let stateId = id.replace('_country','_state');
        let stateField = document.getElementById(stateId);

        if (!stateField) {
            return;
        }

        let optGroups = stateField.querySelectorAll('optgroup');

        for (let i=0; i<optGroups.length; i++) {
            console.log(i);
            let optGroup = optGroups[i];
            if (optGroup.id === stateId + '_' + countryId || optGroup.id === stateId + '_nocountry') {
                optGroup.style.display = 'block';
            } else {
                optGroup.style.display = 'none';
            }
        }

        let selectedStateOption = stateField.options[stateField.selectedIndex];
        if (selectedStateOption.parentElement.style.display === 'none') {
            stateField.selectedIndex = 0;
        }


    }

    document.addEventListener('checkout-address-country-changed', (e) => {
        console.log(e);
        switchStates(e);
    })

})();

